import { RestClient } from './RestClient';
import { IOnlineCondolenceSummary } from '../types/resources/OnlineCondolenceSummary';
import { IApiService } from './IApiService';
import { IOnlineCondolenceDetails } from '../types/resources/OnlineCondolenceDetails';
import {IPost, IPostCreateRequest} from "../types/resources/Post";
import {ICandleLightRequest} from '../types/resources/Candle';

enum Endpoint {
    GetOnlineCondolences = '/OnlineCondolence/GetOnlineCondolences',
    GetOnlineCondolenceByPageUrl = '/OnlineCondolence/GetOnlineCondolenceByPageUrl',
    LightOnlineCondolenceCandle = '/OnlineCondolence/LightOnlineCondolenceCandle',
    CreateOnlineCondolencePost = '/OnlineCondolence/CreateOnlineCondolencePost',
}

export const createApiService = (
    tokenUrl: string,
    apiUrl: string,
    debugMode: boolean,
    useRecaptcha: boolean,
    recaptchaUrl: string,
    companyInfoId?: string,
): IApiService => {
    const client = new RestClient(
        tokenUrl,
        apiUrl,
        debugMode,
        useRecaptcha,
        recaptchaUrl,
        companyInfoId,
    );

    const apiService: IApiService = {
        async getOnlineCondolences(): Promise<IOnlineCondolenceSummary[]> {
            const { success, response} = await client.get(
                Endpoint.GetOnlineCondolences
            );

            return response.data;
        },

        async getOnlineCondolenceByPageUrl(pageUrl: string, securityToken?: string, companyInfoId: string = ''): Promise<IOnlineCondolenceDetails> {
            const params: any = {
                pageUrl: pageUrl,
                securityToken: securityToken,
                companyInfoId: companyInfoId,
            };

            try {
                const { success, response } = await client.get(
                    Endpoint.GetOnlineCondolenceByPageUrl,
                    params,
                );

                if (success && response.data) {
                    return response.data;
                }

                throw {
                    status: response.status,
                    message: response.data,
                };
            }
            catch (error: any) {
                throw error;
            }
        },

        async lightOnlineCondolenceCandle(candleData: ICandleLightRequest): Promise<void> {
            const { success, response} = await client.post(
                Endpoint.LightOnlineCondolenceCandle, {
                    ...candleData,
                }
            );

            if (success) {
                return response.data;
            }

            throw {
                status: response.status,
                message: response.data,
            };
        },

        async createPost(postData: IPostCreateRequest): Promise<IPost> {
            const { success, response } = await client.post(
                Endpoint.CreateOnlineCondolencePost, {
                    ...postData,
                },
            );

            if (success && response.data) {
                return response.data;
            }

            throw {
                status: response.status,
                message: response.data,
            };
        },

        // Reactions TODO
        // async likePost(postId: number): Promise<void> {
        //     await client.post(`/posts/${postId}/like`);
        // },
        // async markPostAsSad(postId: number): Promise<void> {
        //     await client.post(`/posts/${postId}/sad`);
        // },
        // async flagPostAsInappropriate(postId: number): Promise<void> {
        //     await client.post(`/posts/${postId}/flag`);
        // },
    };

    return apiService;
}
